<div id="<%= dom_id cat_extension %>" class="w-full sm:w-auto my-5 space-y-5">
  <div>
    <strong class="block font-medium mb-1">Category:</strong>
    <%= cat_extension.category_id %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Part:</strong>
    <%= cat_extension.part %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Order:</strong>
    <%= cat_extension.order %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Start heat:</strong>
    <%= cat_extension.start_heat %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Day:</strong>
    <%= cat_extension.day %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Time:</strong>
    <%= cat_extension.time %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Duration:</strong>
    <%= cat_extension.duration %>
  </div>
</div>
